<template>
  <div id="pageRoot">
    <letter-picker style="top: 60px; left: 30px;"></letter-picker>
  </div>
</template>
<style scoped>
#bg {
  position: absolute;
  left: 37px;
  top: 47px;
}
#inputField01 {
  position: absolute;
  width: 840px;
  height: 522px;
  left: 37px;
  top: 192px;
  margin-left: 50px;
  margin-top: 10px;
  font-size: 33px;
  font-family: "Courier New", Courier, monospace;
  font-weight: bold;
  z-index: 10;
}
</style>
<script>
export default {
  data() {
    return {
      videos: ["vio/Video 125.p4",]
    }
  }
}
</script>